export default{
  base_url : process.env.VUE_APP_BASE_URL,
  user:null,
  token:null,
  refresh_token: null,
  loader:false,
  showsidebar: true,  
}